import React from 'react'
import PropTypes from 'prop-types'
import { Field, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import { SelectPickerField } from 'components/form/selectpicker'
import TweetField from 'pages/widgets/form/tweet-input/'
import PromotedOnlyCheckboxField from 'pages/widgets/form/promoted-only-checkbox/'

const selector = formValueSelector('widget')

export const SendReplyField = ({ name, selectedAction }) => (
  <div className='row'>
    <div className='col-sm-3 br-no-pad-right component-select-picker'>
      <Field
        name={`${name}.action`}
        component={SelectPickerField}
        defaultValue='SEND_REPLY'
      >
        <option value='SEND_REPLY'>Tweet</option>
        <option value='SEND_DM'>DM</option>
      </Field>
    </div>
    <div
      className={
        (selectedAction === 'SEND_REPLY' ? 'br-has-checkbox ' : 'br-is-dm ') +
        'col-sm-9 br-no-pad-left'
      }
    >
      <TweetField
        messageName={`${name}.message`}
        urlName={`${name}.attachmentUrl`}
        cardUriName={`${name}.cardUri`}
        isDM={selectedAction === 'SEND_DM'}
      />
      {selectedAction === 'SEND_REPLY' ? (
        <PromotedOnlyCheckboxField name={name} />
      ) : null}
    </div>
  </div>
)

SendReplyField.propTypes = {
  name: PropTypes.string,
  selectedAction: PropTypes.string
}

const ReplyWithAction = connect((state, props) => ({
  selectedAction: selector(state, `${props.name}.action`)
}))(SendReplyField)

export default ReplyWithAction



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/twitter/send-reply/index.js